<template>
  <div class="main">
    <div class="main-content">
      <div class="fixed-right-btn">
        <div class="huodong" @click="handleClick">
          <div>{{ $t("helpEarn.huodong") }}</div>
        </div>
        <div class="tuijian" @click="handleClickList">
          <div>{{ $t("helpEarn.tuijian") }}</div>
        </div>
      </div>

      <div class="middle-box">
        <div class="first-image" @click="handleJump('/hasBeenInvited')">
          <div class="first-div">
            <img
              src="../../assets/img/邀请人数.png"
              alt=""
              style="width: 35px; height: 35px"
            />
            <div class="first-div-div">{{ $t("helpEarn.yaoqingrenshu") }}</div>
          </div>
          <div class="first-image-num">
            <span>{{ friendCount }}</span
            >{{ $t("helpEarn.people") }}
          </div>
        </div>
        <div class="second-image" @click="handleJump('/incomeDetails')">
          <div class="first-div">
            <img
              src="../../assets/img/收益.png"
              alt=""
              style="width: 35px; height: 35px"
            />
            <div class="first-div-div">{{ $t("helpEarn.shouyi") }}</div>
          </div>
          <span class="second-image-num"
            ><span>{{ moneyCount }}</span> {{ $t("helpEarn.yuan") }}</span
          >
        </div>
      </div>

      <!-- <div class="footer-box">
        <div class="first-box" id="entop1" :class="{ 'height-high': getLan() }">
          <div class="top" >
            <div class="title">
              {{ $t("helpEarn.yaoqing") }} {{ $t("one") }}
            </div>
            <div class="content-1">{{ $t("helpEarn.yaoqingtext") }}</div>

            <div class="content-2">
              http://www.weopinions.<br />com/register?reco<br />mmendedCode={{
                getUserId()
              }}
            </div>
          </div>
          <div  class="bottom">
            <div @click="toExchange">
              {{ $t("helpEarn.fuzhi") }}
            </div>
          </div>
        </div>
        <div class="second-box" :class="{ 'height-high': getLan() }">
          <div class="top top-1">
            <div class="title">
              {{ $t("helpEarn.yaoqing") }} {{ $t("two") }}
            </div>
            <div class="content-1">{{ $t("helpEarn.yaoqingfs") }}</div>
            <div class="content-2">
              <img src="@/assets/img/qrcode.png" alt="" />
            </div>
          </div>
        </div>
      </div> -->
      <div class="boxs">
        <div class="left">
          <div class="title">{{ $t("helpEarn.yaoqing") }} {{ $t("one") }}</div>
          <div class="content-1">{{ $t("helpEarn.yaoqingtext") }}</div>
          <div class="content-2">
            http://www.weopinions.<br />com/register?uid={{
              getUserId()
            }}
          </div>
          <div class="bottom" @click="toExchange">
            {{ $t("helpEarn.fuzhi") }}
          </div>
        </div>
        <div class="right">
          <div class="title">{{ $t("helpEarn.yaoqing") }} {{ $t("two") }}</div>
          <div class="content-1">{{ $t("helpEarn.yaoqingfs") }}</div>
          <div class="content-2">
            <img src="http://www.weopinions.com/api/v1/RecommendQRCode" alt="" />
          </div>
        </div>
      </div>
    </div>

    <van-dialog
      class="exchange-dialog"
      v-model="showDialog"
      :confirm-button-text="$t('exchangePage.confirm')"
      @confirm="confirm"
    >
      <div class="dialog-info">
        <div>{{ $t("tip") }}</div>
        <div>{{ $t("tipp") }}</div>
      </div>
    </van-dialog>
  </div>
</template>

  <script>
import { AccountsRecommend } from "@/api/api.js";
import { Notify } from "vant";
export default {
  name: "HelpEarn",
  components: {},
  data() {
    return {
      hasInfo: true,
      showDialog: false,
      showUpdateDialog: false,
      friendCount: 0,
      moneyCount: 0,
    };
  },
  computed: {},
  methods: {
    getUserId() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      return loginInfo.id;
    },
    getLan() {
      if (localStorage.getItem("lang") == "en") {
        return true;
      } else {
        return false;
      }
    },
    getSty() {
      return document.documentElement.clientHeight - 60;
    },
    toExchange() {
      if (this.hasInfo) {
        this.showDialog = true;
      } else {
        this.showUpdateDialog = true;
      }
    },
    confirm() {
      let oInput = document.createElement("input");
      oInput.value = `http://www.weopinions.com/register?recommendedCode=${this.getUserId()}`;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
    },
    handleClick() {
      this.$router.push("/ActiveRules");
    },
    handleClickList() {
      this.$router.push("/readRecommend");
    },
    handleJump(routePath) {
      this.$router.push(routePath);
    },

    initPage() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      AccountsRecommend(params).then((res) => {
        if (res.code === 200) {
          this.friendCount = res.data.friendCount;
          this.moneyCount = res.data.moneyCount;
        } else {
          let error = "";
          if (typeof res.errors == "string") {
            error = res.errors;
          } else {
            error = res.errors[0];
          }
          if (error.length > 0) {
            Notify({ type: "danger", message: error });
          }
        }
      });
    },
  },
  mounted() {
    this.initPage();
  },
  activated() {},
};
</script>

  <style lang="stylus" scoped>
  /deep/.main {
    position: relative;
    width: 100%;
    height: 100%;
    // overflow: scroll;
    background: white;
    padding-bottom: 40px;

    .main-content {
      height: 100%;
      box-sizing: border-box;
      overflow: auto;
      background: url('../../assets/img/帮赚背景.png');
      background-size: 100% auto;
      background-repeat: no-repeat;
      padding-bottom: 80px;

      .fixed-right-btn {
        margin-top: 185px;

        div {
          width: 100%;
          height: 0.6rem;
          border-radius: 30px 0 0 30px;
          text-align: right;
          color: #FFFFFF;
        }

        .huodong {
          div {
            width: 17%;
            float: right;
            background: #16A6EE;
            opacity: 0.63;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 0.2rem;
          }

          margin-bottom: 0.2rem;
        }

        .tuijian {
          div {
            width: 23%;
            float: right;
            background: #FF844E;
            opacity: 0.7;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-right: 0.2rem;
          }
        }
      }

      .middle-box {
        margin-top: 0.2rem;
        width: 100%;
        display: flex;
        justify-content: space-around;

        .first-image, .second-image {
          display: flex;
          align-items: center;

          .first-div {
            text-align: center;
            margin-right: 0.2rem;

            .first-div-div {
              margin-top: 0.2rem;
              font-weight: bold;
            }
          }

          .first-image-num {
            font-size: 0.4rem;
            color: #16A6EE;
          }

          .second-image-num {
            font-size: 0.4rem;
            color: #FF7532;
          }
        }
      }

      .footer-box {
        padding: 0 0.4rem;
        margin-top: 1rem;
        box-sizing: border-box;
        width: 100%;
        height: 4rem;
        display: flex;
        justify-content: space-between;

        .first-box, .second-box {
          width: 46%;
          height: 4rem;
          border: 1px solid #FF844E;
          border-radius: 18px;

          .top {
            height: 3.4rem;
            width: 100%;

            .title {
              padding: 8px 5px 5px 5px;
              text-align: center;
              font-weight: bold;
            }

            .content-1 {
              padding: 5px;
              text-align: center;
              line-height: 0.4rem;
            }

            .content-2 {
              text-align: center;
              padding: 2px 2px;
              line-height: 0.3rem;
            }
          }

          .top-1 {
            height: 4rem;

            .content-2 {
              img {
                width: 50%;
                height: 50%;
              }
            }
          }

          .bottom {
            border-top: 1px solid #FF844E;
            height: 0.6rem;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #FF844E;
            font-weight: bold;
          }
        }

        .height-high {
          height: 6rem;

          .top {
            height: 5.4rem;
          }
        }
      }
    }

    .dialog-info {
      text-align: center;

      div:nth-child(1) {
        font-size: 18px;
        line-height: 40px;
      }

      div:nth-child(2) {
        font-size: 14px;
        color: #9F9C9C;
        padding: 0 15px;
        margin-bottom: 15px;
      }
    }
  }

  /deep/ .exchange-dialog {
    .van-button.van-button--default {
      background-color: #97C1E2;

      .van-button__text {
        color: white !important;
      }
    }
  }
</style>
<style scoped>
.boxs {
  display: flex;
  justify-content: space-around;
  min-height: 100px;
  margin-top: 20px;
}
.boxs > .left {
  width: 170px;
  min-height: 100%;
  border: 1px solid #ff844e;
  border-radius: 10px;
  word-wrap: break-word;
  text-align: center;
}
.boxs > .left > .bottom {
  border-top: 1px solid #ff844e;
  text-align: center;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  color: #ff844e;
  margin-top: 10px;
}
.boxs > .left > .title {
  margin-top: 10px;
  font-weight: bold;
}
.boxs > .left > .content-1 {
  margin-top: 10px;
  line-height: 15px;
}
.boxs > .right {
  width: 170px;
  min-height: 100%;
  border: 1px solid #000;
  border: 1px solid #ff844e;
  border-radius: 10px;
  text-align: center;
}
.boxs > .right > .title {
  margin-top: 10px;
  font-weight: bold;
}
.boxs > .right > .content-1 {
  margin-top: 10px;
  line-height: 15px;
}
.boxs > .right > .content-2 > img {
  width: 50%;
  height: 50%;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/helpEarn/HelpEarn.vue